var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 12,
    viewBox: "0 0 38 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.70508C9.26968 4.93419 32.4945 5.3737 32.4945 5.3737M32.4945 5.3737C32.4945 5.3737 29.6187 4.20232 24.5036 3.67529C19.3884 3.14823 18.7148 3.17659 18.7148 3.17659M32.4945 5.3737C32.4945 5.3737 29.7001 5.99661 25.7723 7.12723C25 7.34956 21.6728 8.19542 21.6728 8.19542",
    stroke: "#C691FB",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.7ac1f91b9440061d04ee5267df5a319b.svg";
export { ForwardRef as ReactComponent };